import timedFetch from 'middleware/timedFetch';
import { fetchErrorMiddlewareAllowedErrors } from 'middleware/fetchErrorMiddleware';
import { OutfitApiListResponse } from 'types/outfits';

const OUTFITS_MVP_API_BASE_URL = 'https://d2wqmv008y1iid.cloudfront.net';

// 404s from the API will return an { outfits: [] } are considered valid
export function getOutfits(
  productId: string,
  styleId: string,
  fetcher: (input: RequestInfo, init?: RequestInit | undefined) => Promise<Response<OutfitApiListResponse>> = timedFetch(
    'productOutfits'
  ) as any /* TODO ts Remove once `timedFetch` is typed */
) {
  return fetcher(`${OUTFITS_MVP_API_BASE_URL}/v1/outfits/${productId}/${styleId}.json`, { method: 'GET' }).then(
    fetchErrorMiddlewareAllowedErrors([404])
  );
}
